import { useMemo, useState } from "react";
import { IActionPlan } from "entities/RCA/ActionPlanEntity/ActionPlanEntityInterfaces";
import { useActionPlansEditionContext } from "../../context/ActionPlansEditionContext";

interface IUseActionPlanOwnerCellResult {
    isEditing: boolean;
    assigneeId: string;
    millId: number | undefined;
    handleAssigneeChange: (value: string | number) => void;
}

export const useActionPlanOwnerCell = (row: IActionPlan): IUseActionPlanOwnerCellResult => {
    const { edit, setEdit } = useActionPlansEditionContext();

    const existingEdition = useMemo(() => edit.findIndex((e) => e.id === row.action_plan_id), [edit, row]);
    const assigneeIdChanges = useMemo(
        () => (existingEdition !== -1 ? edit[existingEdition]?.changes?.assignee_id : undefined),
        [edit, existingEdition],
    );

    const initialAssigneeId =
        assigneeIdChanges !== undefined
            ? String(assigneeIdChanges)
            : row.assignee?.user_id
            ? String(row.assignee?.user_id)
            : "";
    const [assigneeId, setAssigneeId] = useState<string>(initialAssigneeId);

    const millId = row.rca?.mill_id || row.issue?.mill_id;

    const handleAssigneeChange = (value: string | number) => {
        const newAssigneeId = typeof value === "string" ? value : String(value);
        setAssigneeId(newAssigneeId);

        if (existingEdition !== -1) {
            setEdit((prevEdit) => {
                const newEdit = [...prevEdit];
                newEdit[existingEdition] = {
                    ...newEdit[existingEdition],
                    changes: {
                        ...newEdit[existingEdition]?.changes,
                        assignee_id: newAssigneeId ? Number(newAssigneeId) : undefined,
                    },
                };
                return newEdit;
            });
        }
    };

    const isEditing = existingEdition !== -1;

    return {
        isEditing,
        assigneeId,
        millId,
        handleAssigneeChange,
    };
};

